var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7811 5.67568L5.72129 1.28417C5.68245 1.25068 5.6329 1.23193 5.58066 1.23193H4.3954C4.29629 1.23193 4.25075 1.35515 4.32575 1.41943L9.01593 5.49086H1.17843C1.1195 5.49086 1.07129 5.53908 1.07129 5.59801V6.40158C1.07129 6.46051 1.1195 6.50872 1.17843 6.50872H9.01459L4.32441 10.5801C4.24941 10.6458 4.29495 10.7676 4.39406 10.7676H5.6195C5.64495 10.7676 5.6704 10.7583 5.68915 10.7409L10.7811 6.3239C10.8275 6.28358 10.8646 6.23378 10.8901 6.17787C10.9156 6.12196 10.9288 6.06123 10.9288 5.99979C10.9288 5.93835 10.9156 5.87762 10.8901 5.82171C10.8646 5.7658 10.8275 5.716 10.7811 5.67568Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.d406d15e732933cc56405bb166ee1418.svg";
export { ForwardRef as ReactComponent };